// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

var Caml_option = require("bs-platform/lib/js/caml_option.js");

function always(x, _y) {
  return x;
}

function compose(f, g, x) {
  return Curry._1(f, Curry._1(g, x));
}

function pipe(f, g, x) {
  return Curry._1(g, Curry._1(f, x));
}

function false_(x) {
  return false;
}

function true_(x) {
  return true;
}

function flip(f, a, b) {
  return Curry._2(f, b, a);
}

function identity(x) {
  return x;
}

var Infix =
/* module */
[
/* <|| */
compose,
/* ||> */
pipe];

function delay(prim, prim$1) {
  return setTimeout(prim, prim$1);
}

function debounce($staropt$star, f, wait) {
  var immediate = $staropt$star !== undefined ? $staropt$star : false;
  var timeout =
  /* record */
  [
  /* contents */
  undefined];

  var afterWait = function afterWait(f) {
    timeout[0] = Caml_option.some(setTimeout(f, wait));
    return (
      /* () */
      0
    );
  };

  return function (param) {
    var match = timeout[0];

    if (immediate) {
      if (match !== undefined) {
        clearTimeout(Caml_option.valFromOption(match));
        return afterWait(function (param) {
          timeout[0] = undefined;
          return (
            /* () */
            0
          );
        });
      } else {
        Curry._1(f,
        /* () */
        0);

        return afterWait(function (param) {
          timeout[0] = undefined;
          return (
            /* () */
            0
          );
        });
      }
    } else if (match !== undefined) {
      clearTimeout(Caml_option.valFromOption(match));
      return afterWait(function (param) {
        Curry._1(f,
        /* () */
        0);

        timeout[0] = undefined;
        return (
          /* () */
          0
        );
      });
    } else {
      return afterWait(function (param) {
        Curry._1(f,
        /* () */
        0);

        timeout[0] = undefined;
        return (
          /* () */
          0
        );
      });
    }
  };
}

function throttle(f, wait) {
  var timeout =
  /* record */
  [
  /* contents */
  undefined];
  var previous =
  /* record */
  [
  /* contents */
  0.0];
  return function (param) {
    var match = timeout[0];

    if (match !== undefined) {
      clearTimeout(Caml_option.valFromOption(match));
      var now = Date.now();
      var remaining = wait - (now - previous[0] | 0) | 0;

      if (remaining <= 0 || remaining > wait) {
        Curry._1(f,
        /* () */
        0);

        previous[0] = Date.now();
        return (
          /* () */
          0
        );
      } else {
        timeout[0] = Caml_option.some(setTimeout(function (param) {
          Curry._1(f,
          /* () */
          0);

          previous[0] = Date.now();
          return (
            /* () */
            0
          );
        }, remaining));
        return (
          /* () */
          0
        );
      }
    } else {
      Curry._1(f,
      /* () */
      0);

      timeout[0] = Caml_option.some(setTimeout(function (param) {
        timeout[0] = undefined;
        return (
          /* () */
          0
        );
      }, wait));
      previous[0] = Date.now();
      return (
        /* () */
        0
      );
    }
  };
}

var $less$pipe$pipe = compose;
var $pipe$pipe$great = pipe;
exports.always = always;
exports.compose = compose;
exports.pipe = pipe;
exports.false_ = false_;
exports.true_ = true_;
exports.flip = flip;
exports.identity = identity;
exports.Infix = Infix;
exports.$less$pipe$pipe = $less$pipe$pipe;
exports.$pipe$pipe$great = $pipe$pipe$great;
exports.delay = delay;
exports.debounce = debounce;
exports.throttle = throttle;
/* No side effect */